module.exports = __webpack_public_path__ + "static/example_2-7434e26fd970d56de758ee75d5585577.jpg";